import React from 'react';
import { cn } from '@/lib/utils';

export const Card = ({ className, ...props }) => (
  <div className={cn('bg-surface border border-white/10 rounded-none', className)} {...props} />
);

export const CardBody = ({ className, ...props }) => (
  <div className={cn('p-6 sm:p-8', className)} {...props} />
);

export const Badge = ({ children, tone = 'default', className }) => {
  const tones = {
    default: 'bg-white/10 text-white',
    volt: 'bg-volt text-black',
    success: 'bg-volt/20 text-volt',
    warning: 'bg-[#FFB800]/20 text-[#FFB800]',
    danger: 'bg-[#FF3B30]/20 text-[#FF3B30]',
  };
  return (
    <span className={cn('inline-flex items-center px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.18em]', tones[tone], className)}>
      {children}
    </span>
  );
};

export const KPI = ({ label, value, hint, icon: Icon, tone }) => (
  <div className="bg-surface-raised border border-white/10 p-6 group hover:border-volt/50 transition-colors">
    <div className="flex items-center justify-between mb-4">
      <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-white/40">{label}</span>
      {Icon && <Icon size={16} className="text-white/30 group-hover:text-volt transition-colors" />}
    </div>
    <div className={cn('font-heading text-4xl sm:text-5xl font-black uppercase leading-none', tone === 'volt' ? 'text-volt' : 'text-white')}>
      {value}
    </div>
    {hint && <p className="text-xs text-white/40 mt-3">{hint}</p>}
  </div>
);
